import Swal from "sweetalert2";
import {
    WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_ERROR,
    WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_REQUEST,
    WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_SUCCESS,
    WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_SUCCESS,
    WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_REQUEST,
    WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_ERROR,
} from "../../Types/user/Types";
import { workspace_Supporting_Documents_Data_Details_ListApi, workspace_Supporting_Documents_Data_Details_Out_Put_ListApi } from "../../Apis/user/ApiConfig";

export const workspaces_Supporting_Documents_Data_Details_List_Success = (res) => {
    return {
        type: WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_SUCCESS,
        payload: res,
    };
};
export const workspaces_Supporting_Documents_Data_Details_List_Error = (error) => {
    return {
        type: WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_ERROR,
        error: error,
    };
};

export const workspaces_Supporting_Documents_Data_Details_List_Request = (res) => {
    return {
        type: WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_REQUEST,
        payload: res,
    };
};


export const workspaces_Supporting_Documents_Data_Details_Out_Put_List_Success = (res) => {
    return {
        type: WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_SUCCESS,
        payload: res,
    };
};
export const workspaces_Supporting_Documents_Data_Details_Out_Put_List_Error = (error) => {
    return {
        type: WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_ERROR,
        error: error,
    };
};

export const workspaces_Supporting_Documents_Data_Details_Out_Put_List_Request = (res) => {
    return {
        type: WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_REQUEST,
        payload: res,
    };
};

export const workspaces_Support_Documents_Data_Details_List_ActionHandler = (
    workspaceId,
    setDatadetalisid,
    search,
    sort,
    page
) => {
    return (dispatch) => {
        dispatch(workspaces_Supporting_Documents_Data_Details_List_Request());
        try {
            workspace_Supporting_Documents_Data_Details_ListApi(workspaceId, setDatadetalisid, search, sort,page)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(
                                workspaces_Supporting_Documents_Data_Details_List_Success(res?.data)
                            );
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Something went wrong!",
                                confirmButtonColor: "rgb(231,52,70)",
                            });
                            dispatch(workspaces_Supporting_Documents_Data_Details_List_Error(res));
                        }
                    } else {
                        dispatch(workspaces_Supporting_Documents_Data_Details_List_Error(""));
                    }
                })
                .catch((err) => {
                    dispatch(
                        workspaces_Supporting_Documents_Data_Details_List_Error(
                            "Something Went Wrong!!!"
                        )
                    );
                });
        } catch (err) {
            dispatch(workspaces_Supporting_Documents_Data_Details_List_Error(err));
        }
    };
};

export const workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler = (
    workspaceId,
    setDatadetalisoutputid,
    search,
    sort,
    page
) => {
    return (dispatch) => {
        dispatch(workspaces_Supporting_Documents_Data_Details_Out_Put_List_Request());
        try {
            workspace_Supporting_Documents_Data_Details_Out_Put_ListApi(workspaceId, setDatadetalisoutputid,search,sort,page)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(
                                workspaces_Supporting_Documents_Data_Details_Out_Put_List_Success(res?.data)
                            );
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Something went wrong!",
                                confirmButtonColor: "rgb(231,52,70)",
                            });
                            dispatch(workspaces_Supporting_Documents_Data_Details_Out_Put_List_Error(res));
                        }
                    } else {
                        dispatch(workspaces_Supporting_Documents_Data_Details_Out_Put_List_Error(""));
                    }
                })
                .catch((err) => {
                    dispatch(
                        workspaces_Supporting_Documents_Data_Details_Out_Put_List_Error(
                            "Something Went Wrong!!!"
                        )
                    );
                });
        } catch (err) {
            dispatch(workspaces_Supporting_Documents_Data_Details_Out_Put_List_Error(err));
        }
    };
};
